import React from 'react';

interface LoadingIndicatorProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function LoadingIndicator({ message = 'Loading...', size = 'md' }: LoadingIndicatorProps) {
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12',
    lg: 'h-16 w-16'
  };

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className={`animate-spin rounded-full border-b-2 border-blue-600 mb-4 ${sizeClasses[size]}`} />
      <p className="text-gray-600">{message}</p>
    </div>
  );
}